var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"free-source"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.breadcrumbs),function(item,i){return _c('el-breadcrumb-item',{key:i,attrs:{"to":{ path: item.path }}},[_vm._v("\n\t\t\t"+_vm._s(item.meta.breadcrumb)+"\n\t\t")])}),1),_c('Tabs',{staticClass:"tabs"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }